import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	id: "Capa_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	style: { enableBackground: "new 0 0 512 512" },
	xmlSpace: "preserve",
	width: "512px",
	height: "512px",
	className: "",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M452,40h-24V0h-40v40H124V0H84v40H60C26.916,40,0,66.916,0,100v352c0,33.084,26.916,60,60,60h392    c33.084,0,60-26.916,60-60V100C512,66.916,485.084,40,452,40z M472,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V188    h432V452z M472,148H40v-48c0-11.028,8.972-20,20-20h24v40h40V80h264v40h40V80h24c11.028,0,20,8.972,20,20V148z",
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 76,
			y: 230,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 156,
			y: 230,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 236,
			y: 230,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 316,
			y: 230,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 396,
			y: 230,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 76,
			y: 310,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 156,
			y: 310,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 236,
			y: 310,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 316,
			y: 310,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 76,
			y: 390,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 156,
			y: 390,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 236,
			y: 390,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 316,
			y: 390,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			x: 396,
			y: 310,
			width: 40,
			height: 40,
			"data-original": "#000000",
			className: "active-path",
			"data-old_color": "#000000"
		}) }) })
	] })
});
export default SvgCalendar;
